import gql from 'graphql-tag';

export interface Postalcode2 {
  id: number;
  postalcode: string | null;
  area: string | null;
  city: string | null;
  county: string | null;
  country: string | null;
  regionId: number | null;
  isActive: boolean | null;
  firstDate: string | null;
  lastDate: string | null;
  firstUser: string | null;
  lastUser: string | null;
  region: string | null;
}

export interface Postalcode2Output {
  data: Postalcode2[];
  recordCount: number;
}

export interface GetPostalcode2QueryVariables {
  limit?: number;
  offset?: number;
  order?: string;
  where?: string;
}

export interface GetPostalcode2ByIdVariables {
  id: number;
}

export interface Region {
  id: number;
  name: string;
}
export interface RegionsOutput {
  data: Region[];
  recordCount: number;
}
export interface GetRegionsQueryVariables {
  limit?: number;
  offset?: number;
  order?: string;
  where?: string;
}

export const gqlGetRegions = gql`
  query getRegions($limit: Int, $offset: Int, $order: String, $where: String) {
    getRegions(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        name
      }
      recordCount
    }
  }
`;

export const gqlGetPostalcode2 = gql`
  query getPostalcode2($limit: Int, $offset: Int, $order: String, $where: String) {
    getPostalcode2(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        postalcode
        area
        city
        county
        country
        regionId
        region {
          id
          name
        }
        isActive
        firstDate
        lastDate
        firstUser
        lastUser
      }
      recordCount
    }
  }
`;

export const gqlGetPostalcode2ById = gql`
  query getPostalcode2ById($id: Int!) {
    getPostalcode2ById(id: $id) {
      id
      postalcode
      area
      city
      county
      country
      regionId
      isActive
      firstDate
      lastDate
      firstUser
      lastUser
      region {
        id
        name
      }
    }
  }
`;

export const gqlUpdatePostalcode2 = gql`
  mutation updatePostalcode2($data: Postalcode2UpdateInput!) {
    updatePostalcode2(data: $data) {
      id
      regionId
      region
    }
  }
`;

export const gqlCreatePostalcode2 = gql`
  mutation createPostalcode2($data: Postalcode2CreateInput!) {
    createPostalcode2(data: $data) {
      id
      regionId
      region
    }
  }
`;

export const gqlDeletePostalcode2 = gql`
  mutation deletePostalcode2($id: Int!) {
    deletePostalcode2(id: $id) {
      id
    }
  }
`;

export const gqlGetRegionById = gql`
  query getRegionById($id: Int!) {
    getRegionById(id: $id) {
      id
      name
    }
  }
`;
